<template>
  <v-app>
    <v-navigation-drawer app dark v-if="showSideBar  && !this.user.isLiveCourseUser" :disable-resize-watcher="false"
                         permanent>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            by Behrendt Consulting GmbH
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>

      <v-list dense nav>
        <div v-for="entry in navigation" :key="entry.title">
          <v-subheader v-if="entry.subheader">{{ entry.subheader }}</v-subheader>
          <v-list-item link :to="entry.route">
            <v-list-item-icon>
              <v-icon>{{ entry.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ entry.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark v-if="showSideBar">
      <div class="d-flex align-center">
        <v-img
            alt=" Logo"
            class="shrink mr-2"
            contain
            src="https://media.visable.com/https://wlw-1-company-facts-media20191122174836234900000006.s3.eu-central-1.amazonaws.com/7c523285-8448-4729-829a-f24372e4922d.jpeg"
            transition="scale-transition"
            width="144"/>
      </div>

      <v-spacer/>

      <v-btn text @click.stop="logout">
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import User from "@/models/User";

export default {
  name: 'App',
  setup() {

  },

  props: {
    keycloak: null
  },

  computed: {
    showSideBar() {
      return this.$route !== undefined && this.$route !== null && this.$route.name !== "Validation" && this.$route.name !== "Home" && this.$route.name !== "PublicCourseList"
    },
    navigation() {
      let routes = [];
      if (this.user.isUser()) {
        routes.push({
          route: "/kurse",
          title: "Schulungen",
          icon: "mdi-ab-testing",
          subheader: "Nutzer: " + this.user.fullName
        })
        routes.push({route: "profil", title: "Profil", icon: "mdi-face-man-profile"})
      }
      if (this.user.isAdminOfCompany) {
        routes.push({route: "nutzer", title: "Nutzerverwaltung", icon: "mdi-head-outline", subheader: "Firma"})
        routes.push({route: "lizenzen", title: "Lizenzverwaltung", icon: "mdi-license"})
        routes.push({route: "einstellungen", title: "Einstellungen", icon: "mdi-cog-outline"})
      }
      if (this.user.isSuperAdmin()) {
        routes.push({
          route: "superadmin-nutzer",
          title: "Nutzersuche",
          icon: "mdi-head-outline",
          subheader: "Superadmin"
        })
        routes.push({route: "superadmin-firmen", title: "Firmenverwaltung", icon: "mdi-domain"})
        routes.push({
          route: "superadmin-schulungen",
          title: "Schulungsverwaltung",
          icon: "mdi-database-settings-outline"
        })
        routes.push({route: "superadmin-pakete", title: "Paketverwaltung", icon: "mdi-package-variant"})
        routes.push({route: "superadmin-pdfs", title: "PDF Dateien", icon: "mdi-file"})
        routes.push({route: "superadmin-csv", title: "Live Kurse", icon: "mdi-broadcast"})
        routes.push({route: "superadmin-sync-issues", title: "Sync-Probleme", icon: "mdi-lan-disconnect"})
        routes.push({route: "superadmin-certUpload", title: "Manueller Zertifikatsupload", icon: "mdi-upload"})
        routes.push({route: "superadmin-certSearch", title: "Zertifikatssuche", icon: "mdi-certificate-outline"})
        routes.push({route: "superadmin-buycourse", title: "Schulungsanmeldungen", icon: "mdi-presentation"})
      }
      routes.push({route: "validation", title: "Zertifikat Validieren", icon: "mdi-check-all", subheader: "Anderes"})
      return routes;
    }
  },

  data: () => ({
    title: "",
    user: new User({})
  }),

  mounted() {
    this.$httpUserApi.get((user) => {
      this.user = user;
      if (!user.isSuperAdmin()) {
        this.$httpCompanyApi.get(user.companyId, (company) => {
          this.title = company.name ?? "";
        }, () => {
          this.title = "Behrendt";
        });
      } else {
        this.title = "Behrendt Superadmin";
      }
    });

  },
  methods: {
    logout() {
      this.$router.push(this.$router.resolve({name: "Home"}).route.path, () => {
        this.keycloak.logout();
      });
    }
  }
};
</script>


<style>

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
<style lang="sass">
@import '../node_modules/typeface-roboto/index.css'
</style>
